import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { renderFullDate } from '../../../utils/time'
import { hasSubscriptionPermission, hasAccess } from '../../../utils/auth'
import { translation } from '../../../utils/helpers'
// Constants
// import HelpText from '../../../shared/components/HelpText'
import { triggerPopupActionBG } from '../../../actions/backdrop'

import Button from '../../../shared/elements/button'
import LabelWrapper from '../../../shared/elements/labelWrapper'
import Icon from '../../../shared/elements/icon'
import Inline from '../../../shared/elements/inline'

class OrderBookingButton extends PureComponent {

  constructor (props) {
    super(props)
    this.state = {
    }
    this.renderBookExternalLak = this.renderBookExternalLak.bind(this)
  }

  componentDidMount () {
  }
  shouldComponentUpdate (nextProps) {
    return this.props.order !== nextProps.order
  }

  renderBookExternalLak () {
    const { order, regularBooking, disabled } = this.props
    const { allowNoCustomer, departmentType, user } = this.props.auth
    let missingBodywork = !order.IsBodyShopOrder
    let bookingStopped = order.IsAgreementForsiCreated && !order.IsEvaluation
    let evaluationStopped = ((!order.IsEvaluation || (order.IsEvaluation && !order.IsEvaluated)) && order.CustomerWPEvaluationRequired && order.IsAgreementOrder) ||
      (departmentType === 0 && (!order.IsEvaluation || (order.IsEvaluation && !order.IsEvaluated)) && order.CustomerWPEvaluationRequired && order.IsAgreementOrder)
    let evaluationRejected = order.IsEvaluation && !order.IsEvaluated && order.IsEvaluationRejected && order.CustomerWPEvaluationRequired && order.IsAgreementOrder
    let bookingButtonClass = 'BookPaintBTN'
    let bookingButtonLabel = ''
    let bookingStoppedLabel = ''
    if (bookingStopped) {
      bookingButtonClass += ' disabled hint--left'
      bookingButtonLabel += ' ' + translation('13568')
      bookingStoppedLabel = translation('13568')
    } else if (evaluationStopped) {
      const evaluationRequiredTxt = order.IsEvaluation ? translation('13038') : translation('15177')
      bookingButtonClass += ' disabled hint--left'
      bookingButtonLabel += ' ' + evaluationRequiredTxt
      bookingStoppedLabel = evaluationRequiredTxt
    }
    const bookingStoppedToast = () => {
      window.toastr.error(order.IsEvaluation ? translation('13038') : translation('15177'))
      if (!order.IsEvaluation && !order.IsEvaluated) {
        this.props.togglePopup.bind(this, 'createEstimationPopup')()
      }
    }
    let requireCustomerStopped = order.ForsiReportId !== null && order.CustomerSelect === 1 && !allowNoCustomer

    if (regularBooking) {
      bookingButtonClass = ''
      bookingButtonLabel = ''
      bookingStoppedLabel = ''
      if (departmentType !== 1) {
        if (requireCustomerStopped || bookingStopped || evaluationStopped || evaluationRejected) {
          bookingButtonClass += ' disabled hint--left'
        }
        if (requireCustomerStopped) {
          bookingButtonLabel += ' ' + translation('14910')
          bookingStoppedLabel = translation('14910')
        } else if (bookingStopped) {
          bookingButtonLabel += ' ' + translation('13568')
          bookingStoppedLabel = translation('13568')
        } else if (evaluationStopped && !evaluationRejected) {
          const evaluationRequiredTxt = order.IsEvaluation ? translation('13038') : translation('15177')
          bookingButtonLabel += ' ' + evaluationRequiredTxt
          bookingStoppedLabel = evaluationRequiredTxt
        } else if (evaluationRejected) {
          bookingButtonClass += ' disabled hint--left'
          bookingButtonLabel += ' ' + translation('14929')
          bookingStoppedLabel = translation('14929')
        }
      }
      const onClick = () => {
        if (bookingStopped || evaluationRejected) {
          this.props.togglePopup.bind(this, 'createEstimationPopup')
        } else if (evaluationStopped) {
          bookingStoppedToast()
        }
      }
      let department = order.OrderDepartment
      let renderBodyCustomer = order.BodyShopIsDraft === true && hasAccess([4], user.UserType)
      let renderBodyShop = department === 1 && order.BodyShopIsDraft === true && !hasAccess([4], user.UserType)
      if (((department !== 1 && order.IsDraft) || (renderBodyShop) || (renderBodyCustomer)) !== true) return null
      return (
        <div className='actions'>
          {department !== 1 && order.IsDraft && (
            <div>
              {(bookingStopped || evaluationStopped || evaluationRejected) && (
                <div
                  className='left hint--left'
                  aria-label={bookingStoppedLabel}
                >
                  <img src={'/images/icons/Stop-31.png'} onClick={onClick} />
                </div>
              )}
              {hasSubscriptionPermission(this.props.auth, 0, 2) && (
                <Button
                  style='cta'
                  size='m'
                  spacing={0}
                  className={bookingButtonClass}
                  aria-label={bookingButtonLabel}
                  disabled={disabled || this.state.updating}
                  onClick={bookingStopped || evaluationRejected ? this.props.togglePopup.bind(this, 'createEstimationPopup') : evaluationStopped ? bookingStoppedToast : this.props.bookOrder.bind(this, undefined, false)}
                >
                  {translation('13384')}
                </Button>
              )}
            </div>
          )}

          { /* Book knappen for værkstedet */}
          {renderBodyShop && (
            <div>
              {departmentType === 0 && (bookingStopped || evaluationStopped || evaluationRejected) && (
                <div
                  className='left hint--left'
                  aria-label={bookingStoppedLabel}
                >
                  <img src={'/images/icons/Stop-31.png'} onClick={onClick} />
                </div>
              )}

              {(requireCustomerStopped) && (
                <div
                  className='left hint--left'
                  aria-label={bookingStoppedLabel}
                >
                  <img className='customer_stop' src={'/images/svgs/stop-customer.svg'} onClick={this.props.togglePopup.bind(this, 'showSetCustomerPopup')} />
                </div>
              )}

              {!requireCustomerStopped && department !== 0 && order.BodyShopIsDraft && hasSubscriptionPermission(this.props.auth, 0, 2) && (
                <Button
                  style='cta'
                  size='m'
                  spacing={0}
                  className={bookingButtonClass}
                  aria-label={bookingButtonLabel}
                  disabled={disabled || this.state.updating}
                  onClick={bookingStopped /* || evaluationRejected */ ? this.props.togglePopup.bind(this, 'createEstimationPopup') : missingBodywork ? this.props.togglePopup.bind(this, 'confirmMissingBodywork') : this.props.bookOrder.bind(this, undefined, true)}
                >
                  {translation('13384')}
                </Button>
              )}

              {requireCustomerStopped && order.BodyShopIsDraft && hasSubscriptionPermission(this.props.auth, 0, 2) && (
                <Button
                  style='cta'
                  size='m'
                  spacing={0}
                  className={bookingButtonClass}
                  aria-label={bookingButtonLabel}
                  disabled={disabled || this.state.updating}
                  onClick={this.props.togglePopup.bind(this, 'showSetCustomerPopup')}
                >
                  {translation('13384')}
                </Button>
              )}
            </div>
          )}

          { /* Book knappen som kunden vil se */}
          {renderBodyCustomer && (
            <div>
              {order.BodyShopIsDraft && hasSubscriptionPermission(this.props.auth, 0, 2) && (
                <Button
                  style='cta'
                  size='m'
                  spacing={0}
                  className={bookingButtonClass}
                  aria-label={bookingButtonLabel}
                  disabled={disabled || this.state.updating}
                  onClick={this.props.bookOrder.bind(this, undefined, true)}
                >
                  {translation('13384')}
                </Button>
              )}
            </div>
          )}
        </div>
      )
    }
    // if (departmentType === 1) {
    if (order.OrderDepartment === 1 && order.HasAvailablePaintPartner) {
      if (order.IsDraft) {
        return (
          <Inline fillChildNum={[1]} block>
            {(bookingStopped || evaluationStopped) && (<Icon size='m' icon={{ fileName: '/images/icons/Stop-31.png' }} ariaText={bookingStoppedLabel} onClick={bookingStopped ? this.showCreateEstimationPopup : bookingStoppedToast} />)}
            {order.IsDraft && hasSubscriptionPermission(this.props.auth, 0, 2) && (
              <Button
                style='link'
                spacing={0}
                className={bookingButtonClass}
                aria-label={bookingButtonLabel}
                disabled={disabled || this.state.updating}
                onClick={bookingStopped ? this.showCreateEstimationPopup : evaluationStopped ? bookingStoppedToast : this.props.bookOrder.bind(this, undefined, false, false, true)}
              >
                {translation('13384')}
              </Button>
            )}
            <div className='clearFix' />
          </Inline>
        )
      } else {
        return (
          <LabelWrapper
            labelText={translation('13532')}
            helpText={translation('13011') + ': ' + order.PublishedBy + '\n' + translation('388') + ': ' + renderFullDate(order.PublishDate) + '\n' + translation('1052') + ': ' + order.PublishedByMail + '\n' + translation('38') + ': ' + order.PublishedByMobile}
          />
        )
      }
    }
  }
  render () {
    if (!this.props.order) return null

    if (this.props.regularBooking) {
      return this.renderBookExternalLak()
    }

    return (
      <div className=''>
        {this.renderBookExternalLak()}
      </div>
    )
  }
}

OrderBookingButton.defaultProps = {
  isBodyshop: false,
  disabled: false,
  onUpdateOrder: () => {
    console.log('onUpdateOrder default')
  },
  togglePopup: () => {
    console.log('togglePopup default')
  },
  bookOrder: () => {
    console.log('bookOrder default')
  },
  regularBooking: false
}

OrderBookingButton.propTypes = {
  onUpdateOrder: PropTypes.func,
  togglePopup: PropTypes.func,
  bookOrder: PropTypes.func,
  isBodyshop: PropTypes.bool,
  regularBooking: PropTypes.bool,
  order: PropTypes.object.isRequired,
  disabled: PropTypes.bool.isRequired
}

OrderBookingButton.contextTypes = {
  router: PropTypes.object.isRequired
  // t: React.PropTypes.func.isRequired,
  // enum: React.PropTypes.func.isRequired
}
function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}
export default connect(mapStateToProps, {
  triggerPopupActionBG
})(OrderBookingButton)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/OrderBookingButton/index.js